import type { UpdateBirthRequest } from '@lunya/contracts'

import { toIsoDate } from '../../utils'

export type UpdateBirthInput = {
  date: Date
  time?: string | null
  cityId?: string | null
}

/** Клиентский черновик данных рождения (A2) → тело `PATCH /users/me/birth`. */
export function mapBirthToApi(input: UpdateBirthInput): UpdateBirthRequest {
  return {
    birth_date: toIsoDate(input.date),
    birth_time: input.time ?? null,
    birth_city_id: input.cityId ?? null,
  }
}
